import styled from "styled-components";

export const Page = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  max-width: 480px;
  width: 100%;
  margin: 0 auto;
  background-color: white;
`;

export const Header = styled.div`
  padding: 20px;
  text-align: center;
  font-size: 18px;
  font-weight: 600;
  border-bottom: 1px solid #e0e0e0;
`;

export const TabContainer = styled.div`
  display: flex;
  border-bottom: 2px solid #e0e0e0;
`;

export const Tab = styled.div<{ active: boolean }>`
  flex: 1;
  padding: 16px;
  text-align: center;
  font-size: 16px;
  font-weight: ${props => props.active ? '600' : '400'};
  color: ${props => props.active ? '#000' : '#999'};
  border-bottom: ${props => props.active ? '3px solid #1FBC70' : 'none'};
  margin-bottom: -2px;
  cursor: pointer;
  transition: all 0.3s ease;

  &:hover {
    color: #000;
  }
`;

export const ContentWrap = styled.div`
  padding: 24px 7%;
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

export const SectionTitle = styled.div`
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 12px;
  text-align: left;
`;

export const InputGroup = styled.div`
  display: flex;
  gap: 10px;
  align-items: center;
`;

export const InputContainer = styled.div`
  position: relative;
  width: 100%;
`;

export const InputWrap = styled.div`
  width: 100%;
  height: 50px;
  display: flex;
  align-items: center;
  border-radius: 10px;
  background-color: #F5F5F5;
  padding: 0 16px;

  input, select {
    flex: 1;
    font-size: 15px;
    border: none;
    outline: none;
    background-color: transparent;
    color: #000;

    &::placeholder {
      color: #999;
    }
  }

  select {
    cursor: pointer;
  }
`;

export const Input = styled.input`
  width: 100%;
  height: 48px;
  padding: 0 48px 0 16px;
  border: none;
  border-radius: 10px;
  background-color: #F0F0F0;
  font-size: 15px;
  color: #000;
  outline: none;

  &::placeholder {
    color: #999;
  }
`;

export const SearchContainer = styled.div`
  position: relative;
  width: 100%;
`;

export const EmailContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
`;

export const ClearButton = styled.button`
  position: absolute;
  right: 16px;
  top: 50%;
  transform: translateY(-50%);
  width: 24px;
  height: 24px;
  border: none;
  background: #999;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  padding: 0;
`;

export const ClearIcon = styled.span`
  color: white;
  font-size: 18px;
  font-weight: 300;
  line-height: 1;
`;

export const DropdownList = styled.div`
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  margin-top: 8px;
  background: white;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  max-height: 300px;
  overflow-y: auto;
  z-index: 10;
`;

export const DropdownItem = styled.div<{ selected?: boolean }>`
  padding: 16px 20px;
  cursor: pointer;
  font-size: 16px;
  color: ${props => props.selected ? '#1FBC70' : '#000'};
  background-color: ${props => props.selected ? '#F0FFF5' : 'white'};
  text-align: left;

  &:hover {
    background-color: #F8F8F8;
  }

  &:first-child {
    border-top-left-radius: 12px;
    border-top-right-radius: 12px;
  }

  &:last-child {
    border-bottom-left-radius: 12px;
    border-bottom-right-radius: 12px;
  }
`;

export const NoResult = styled.div`
  padding: 20px;
  text-align: center;
  color: #999;
  font-size: 14px;
`;

export const VerifyButton = styled.button`
  height: 48px;
  padding: 0 20px;
  border: none;
  border-radius: 10px;
  background-color: #1FBC70;
  color: white;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  white-space: nowrap;
  flex-shrink: 0;

  &:hover {
    background-color: #18a860;
  }

  &:active {
    background-color: #159150;
  }

  &:disabled {
    background-color: #D9D9D9;
    cursor: not-allowed;
  }
`;

export const Timer = styled.div`
  position: absolute;
  right: 20px;
  top: 50%;
  transform: translateY(-50%);
  color: #1FBC70;
  font-size: 14px;
  font-weight: 600;
`;

export const TimerExpired = styled.div`
  position: absolute;
  right: 20px;
  top: 50%;
  transform: translateY(-50%);
  color: #FF4444;
  font-size: 14px;
  font-weight: 600;
`;

export const BottomButton = styled.button`
  position: fixed;
  bottom: 20px;
  left: 50%;
  transform: translateX(-50%);
  width: calc(100% - 48px);
  max-width: calc(480px - 48px);
  height: 52px;
  border: none;
  font-weight: 600;
  font-size: 16px;
  background-color: #CCCCCC;
  border-radius: 12px;
  color: white;
  cursor: pointer;

  &.active {
    background-color: #1FBC70;

    &:hover {
      background-color: #18a860;
    }

    &:active {
      background-color: #159150;
    }
  }
`;

export const ErrorMessage = styled.div`
  margin-top: 8px;
  color: #FC324A;
  font-size: 13px;
`;

export const SuccessMessage = styled.div`
  margin-top: 8px;
  color: #1FBC70;
  font-size: 13px;
`;
